import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ca88588"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comp-bar" }
const _hoisted_2 = { class: "comp-bar-row" }
const _hoisted_3 = { class: "comp-bar-column" }
const _hoisted_4 = { class: "position-relative" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-circle-left" })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-icon-bg" }, null, -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  id: "compContainer",
  ref: "compContainer"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "move-left ms-2",
  "data-action": "move-left"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-left" })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "drag-tab ms-2",
  "data-action": "move-tab"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-grip-vertical" })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "move-right ms-2",
  "data-action": "move-right"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-right" })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "comp-remove ms-2",
  "data-action": "delete-tab"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
], -1))
const _hoisted_14 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "address address-1" }
const _hoisted_16 = { class: "address address-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-circle-right" })
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-icon-bg" }, null, -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "tab-navigation tab-navigation-left",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollLeft && _ctx.scrollLeft(...args)))
            }, _hoisted_7),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_draggable, _mergeProps({
                tag: "ul",
                handle: ".drag-tab",
                modelValue: _ctx.compsData,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.compsData) = $event)),
                move: _ctx.onMoveCompCheck
              }, _ctx.dragOptions, { onChange: _ctx.onCompDrop }), {
                default: _withCtx(() => [
                  _createVNode(_TransitionGroup, {
                    type: "transition",
                    name: "flip-list"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.compsData, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: item.compNumber,
                          class: _normalizeClass([_ctx.setTabFocus(item.isActive), _ctx.isLoading(item.isLoading)]),
                          onClick: ($event: any) => (_ctx.tabAction($event, index, item.isLoading)),
                          "data-action": "select-tab"
                        }, [
                          (!item.isActive && item.isLoading)
                            ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
                            : _createCommentVNode("", true),
                          (item.compNumber > 0)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(["tab-actions", [_ctx.isLoading(item.isLoading)]])
                              }, _hoisted_14, 2))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", null, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["has-viewed-icon", _ctx.hasCompViewed(item.hasVisited)])
                            }, null, 2),
                            _createTextVNode(" " + _toDisplayString(_ctx.compNumber(item.compNumber)) + " ", 1),
                            _createElementVNode("div", _hoisted_15, _toDisplayString(item.address.address1), 1),
                            _createElementVNode("div", _hoisted_16, _toDisplayString(item.address.address2), 1)
                          ])
                        ], 10, _hoisted_9))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 16, ["modelValue", "move", "onChange"])
            ], 512),
            _createElementVNode("div", {
              class: "tab-navigation tab-navigation-right",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.scrollRight && _ctx.scrollRight(...args)))
            }, _hoisted_19)
          ])
        ])
      ])
    ]),
    (_ctx.modalConfirmation.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalConfirmation.component), {
          key: 0,
          message: _ctx.modalConfirmation.message,
          buttons: _ctx.modalConfirmation.buttons,
          modalSize: _ctx.modalConfirmation.size,
          onHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalConfirmation.show = false))
        }, null, 8, ["message", "buttons", "modalSize"]))
      : _createCommentVNode("", true)
  ], 64))
}